import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63b95635"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nombre" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-medium-emphasis" }, "contra", -1))
const _hoisted_3 = { class: "text-right" }
const _hoisted_4 = { class: "text-right" }


import type { CruceResumenDTO } from "@/interfaces/Estadisticas";
import {
  colorRinde,
  textoPorcentaje,
  textoRinde,
} from "@/utils/estadisticasEjercitos";


export default /*#__PURE__*/_defineComponent({
  __name: 'FilaCruce',
  props: {
    cruce: {}
  },
  emits: ["elegir"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const elegir = () =>
  emit("elegir", { ejercito: props.cruce.ejercito, rival: props.cruce.rival });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "fila pulsable text-body-2",
    role: "button",
    tabindex: "0",
    onClick: elegir,
    onKeydown: _withKeys(elegir, ["enter"])
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createTextVNode(_toDisplayString(_ctx.cruce.ejercito) + " ", 1),
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_ctx.cruce.rival), 1)
    ]),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.cruce.partidas), 1),
    _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(textoPorcentaje)(_ctx.cruce.porcentaje)), 1),
    _createElementVNode("span", {
      class: _normalizeClass(["text-right", _unref(colorRinde)(_ctx.cruce.rinde)])
    }, _toDisplayString(_unref(textoRinde)(_ctx.cruce.rinde)), 3)
  ], 32))
}
}

})